import React, { useState } from 'react'

import { Button, Row } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

import TasksList from './taskList'
import FormTask from '../task/form'
import FormAssign from '../assign/form'

import {
  useUpdateTaskStatus,
  useRemoveTask
} from '../../../../hooks/manager/job'

const CustomTasksList = (props) => {
  const {
    allowNewTask,
    allowUpdateStatus,
    job,
    catlogs,
    allowEdit
  } = props
  const { id } = job

  const { mutate: updateTaskStatus, isLoading: isUpdateStatusLoading } = useUpdateTaskStatus(id)
  const { mutate: removeTask, isLoading: isRemoveLoading } = useRemoveTask(id)

  const actionLoading = isUpdateStatusLoading || isRemoveLoading || props.actionLoading

  const [modalAssignVisible, setModalAssignVisible] = useState(false)
  const [modalNewVisible, setModalNewVisible] = useState(false)

  const [task, setTask] = useState(null)

  const isModalActive = modalNewVisible

  const onModalEdit = (record) => {
    setTask(record)
    setModalNewVisible(true)
  }

  const onModalAssign = (record) => {
    setTask(record)
    setModalAssignVisible(true)
  }

  return (
    <>
      {allowNewTask && (
        <Row justify='end'>
          <div style={{ padding: 10 }}>
            <Button
              size='small'
              type='primary'
              icon={<PlusOutlined />}
              onClick={() => setModalNewVisible(true)}
              disabled={modalNewVisible}
              loading={modalNewVisible}
            >
              New Tasks
            </Button>
          </div>
        </Row>
      )}

      <TasksList
        tasks={job.tasks}
        onModalEdit={onModalEdit}
        onModalAssign={onModalAssign}
        allowUpdateStatus={allowUpdateStatus}
        isModalActive={isModalActive}
        updateTaskStatus={updateTaskStatus}
        actionLoading={actionLoading}
        allowEdit={allowEdit}
        removeTask={removeTask}
      />

      {modalNewVisible && (
        <FormTask
          visible={modalNewVisible}
          handleCancel={() => {
            setModalNewVisible(false)
            setTask(null)
          }}
          id={job.id}
          catlogs={catlogs}
          task={task}
        />
      )}
      {modalAssignVisible && (
        <FormAssign
          visible
          onCancel={() => {
            setModalAssignVisible(false)
            setTask(null)
          }}
          id={job.id}
          taskId={task.id}
        />
      )}
    </>
  )
}

export default CustomTasksList
